export default {
  // 404 Not Found page
  path: '*',
  component: () => import('@/components/pages/NotFound')
}
